var map = {
	"./ages-branco.svg": "4b0c",
	"./fadergs-branco.svg": "8d26",
	"./faseh-branco.svg": "fd4b",
	"./fpb-branco.svg": "947f",
	"./ibmr-branco.svg": "ffc8",
	"./mcampos-branco.svg": "9b4c",
	"./sociesc-branco.svg": "f2d7",
	"./uam-branco.svg": "1310",
	"./una-branco.svg": "10ed",
	"./unibh-branco.svg": "1327",
	"./unicuritiba-branco.svg": "78fb",
	"./unifacs-branco.svg": "f45b",
	"./unifg-branco.svg": "4b70",
	"./unifgua-branco.svg": "1f63",
	"./uniritter-branco.svg": "5a6b",
	"./unisul-branco.svg": "8ef5",
	"./unp-branco.svg": "6e89",
	"./usjt-branco.svg": "3f92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "828b";